import React from 'react';
import { Text } from 'react-easy-i18n';
import config from '../../config/config'
import branding from '../../config/branding'
import localise from "../../tools/localise";

import './footer.scss'

export default function Footer(props) {

    const brand = branding[config.brandId]
    const footerLogo = brand.footerLogo ? config.getImage(brand.footerLogo) : null

    const t = 'footer'
    
    const privacyLink = localise.getString(t + '.privacyPolicyLink')
    const termsLink = localise.getString(t + '.termsOfUseLink')
    const copyright = localise.getString(t + '.copyright')

    // Check if translations returned actual values (not the keys themselves)
    const hasPrivacyLink = privacyLink && privacyLink !== `${t}.privacyPolicyLink`
    const hasTermsLink = termsLink && termsLink !== `${t}.termsOfUseLink`
    const hasCopyright = copyright && copyright !== `${t}.copyright`

    return (
      <footer className="app-footer row">
        <section className='cochlear-footer container-fluid' aria-label='page footer'>

        <div className='content'>

          {footerLogo && (
            <div className='footer-logo'>
              <img src={footerLogo} alt='logo' />
              <Text className='logotag' text={`${t}.Clinical use only`} /> 
            </div>
          )}

          {(hasPrivacyLink || hasTermsLink) && (
            <div className="footer-links">
              {hasPrivacyLink && (
                <a className='flex-nowrap'
                  href={privacyLink}
                  target="_blank" 
                  rel="noopener noreferrer" >
                  <Text text={`${t}.privacy`} /> 
                </a>
              )}

              {hasTermsLink && (
                <a className='flex-nowrap'
                  href={termsLink}
                  target="_blank" 
                  rel="noopener noreferrer" >
                  <Text text={`${t}.termsOfUse`} /> 
                </a>
              )}
            </div>
          )}

          {hasCopyright && (
            <div className='copyright'><Text text={`${t}.copyright`} /></div>
          )}

        </div>

        </section>
        
      </footer>
    )
}